import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceSignaling, TrafficSign, VerticalSignaling } from 'src/models';
import { DeviceSignalingMinimumStock, StockedDeviceSignaling, StockedSupport, StockedTrafficSign, SupportMinimumStock, TrafficSignMinimumStock } from 'src/models/stock';
import { RestApiService } from './rest-api.service';
import { DashboardService } from './dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class StockService extends RestApiService {

  _urlStockedTrafficSign = '/stocked-traffic-signs'
  _urlStockedTrafficSignId = '/stocked-traffic-signs/:id'
  _urlStockedSupport = '/stocked-supports'
  _urlStockedSupportId = '/stocked-supports/:id'
  _urlStockedDevice = '/stocked-device-signalings'
  _urlStockedDeviceId = '/stocked-device-signalings/:id'
  _urlTrafficSignMinStock = '/traffic-sign-minimum-stock'
  _urlTrafficSignMinStockId = '/traffic-sign-minimum-stock/:id'
  _urlSupportMinStock = '/support-minimum-stock'
  _urlSupportMinStockId = '/support-minimum-stock/:id'
  _urlDeviceMinStock = '/device-signaling-minimum-stock'
  _urlDeviceMinStockId = '/device-signaling-minimum-stock/:id'
  _urlTrafficSigns = '/traffic-signs'
  _urlDeviceSignaling = '/device-signalings'



  constructor(public http: HttpClient, private dashboardService: DashboardService) {
    super(http)
  }

  createTrafficSignStock(trafficSignStockBody: StockedTrafficSign) {
    const url = this._urlStockedTrafficSign
    return this.post(url, trafficSignStockBody, StockedTrafficSign)
  }

  getStockedTrafficSign(contractId?, startDate?: Date, endDate?: Date, optionsFilter?: any) {
    let url = this._urlStockedTrafficSign + '?' + (contractId ? `contractId=${contractId}` : '');
    if (startDate) {
      const start = startDate.toISOString();
      url += `startDate=${start}&`;
    }

    if (endDate) {
      const end = endDate.toISOString() || new Date().toISOString();
      url += `endDate=${end}&`;

    }
    url = this.dashboardService.createFilterUrl(url, optionsFilter);
    return this.get(url, StockedTrafficSign)
  }

  getStockedTrafficSignById(entryId: string) {
    const url = this._urlStockedTrafficSignId.replace(':id', entryId)
    return this.get(url, StockedTrafficSign)
  }

  editStockedTrafficSign(trafficSignStockBody: StockedTrafficSign) {
    const url = this._urlStockedTrafficSignId.replace(':id', trafficSignStockBody.id)
    return this.put(url, trafficSignStockBody, StockedTrafficSign)
  }

  deleteStockedTrafficSign(entryId: string) {
    const url = this._urlStockedTrafficSignId.replace(':id', entryId)
    return this.del(url, StockedTrafficSign)
  }

  createSupportStock(supportStockBody: StockedSupport) {
    const url = this._urlStockedSupport
    return this.post(url, supportStockBody, StockedSupport)
  }

  getStockedSupport(contractId?, startDate?: Date, endDate?: Date, optionsFilter?: any) {
    let url = this._urlStockedSupport + '?' + (contractId ? `contractId=${contractId}` : '')
    if (startDate) {
      const start = startDate.toISOString();
      url += `startDate=${start}&`;
    }

    if (endDate) {
      const end = endDate.toISOString() || new Date().toISOString();
      url += `endDate=${end}&`;

    }
    url = this.dashboardService.createFilterUrl(url, optionsFilter);
    return this.get(url, StockedSupport)
  }

  getStockedSupportById(entryId: string) {
    const url = this._urlStockedSupportId.replace(':id', entryId)
    return this.get(url, StockedSupport)
  }

  editStockedSupport(supportStockBody: StockedSupport) {
    const url = this._urlStockedSupportId.replace(':id', supportStockBody.id)
    return this.put(url, supportStockBody, StockedSupport)
  }

  deleteStockedSupport(entryId: string) {
    const url = this._urlStockedSupportId.replace(':id', entryId)
    return this.del(url, StockedSupport)
  }

  createDeviceStock(deviceStockBody: StockedDeviceSignaling) {
    const url = this._urlStockedDevice
    return this.post(url, deviceStockBody, StockedDeviceSignaling)
  }

  getStockedDevice(contractId?, startDate?: Date, endDate?: Date, optionsFilter?: any) {
    let url = this._urlStockedDevice + '?' + (contractId ? `contractId=${contractId}` : '')
    if (startDate) {
      const start = startDate.toISOString();
      url += `startDate=${start}&`;
    }

    if (endDate) {
      const end = endDate.toISOString() || new Date().toISOString();
      url += `endDate=${end}&`;

    }

    url = this.dashboardService.createFilterUrl(url, optionsFilter);
    return this.get(url, StockedDeviceSignaling)
  }

  getStockedDeviceById(entryId: string) {
    const url = this._urlStockedDeviceId.replace(':id', entryId)
    return this.get(url, StockedDeviceSignaling)
  }

  editStockedDevice(deviceStockBody: StockedDeviceSignaling) {
    const url = this._urlStockedDeviceId.replace(':id', deviceStockBody.id)
    return this.put(url, deviceStockBody, StockedDeviceSignaling)
  }

  deleteStockedDevice(entryId: string) {
    const url = this._urlStockedDeviceId.replace(':id', entryId)
    return this.del(url, StockedDeviceSignaling)
  }

  // Estoque Mínimo
  createTrafficSignMinStock(trafficSignMinStockBody: TrafficSignMinimumStock) {
    const url = this._urlTrafficSignMinStock
    return this.post(url, trafficSignMinStockBody, TrafficSignMinimumStock)
  }

  getTrafficSignMinStock(contractId?: string) {
    const url = this._urlTrafficSignMinStock + (contractId ? `?contractId=${contractId}` : '')
    return this.get(url, TrafficSignMinimumStock)
  }

  editTrafficSignMinStock(trafficSignMinStockBody: TrafficSignMinimumStock) {
    const url = this._urlTrafficSignMinStockId.replace(':id', trafficSignMinStockBody.id)
    return this.put(url, trafficSignMinStockBody, TrafficSignMinimumStock)
  }

  deleteTrafficSignMinStock(stockId) {
    const url = this._urlTrafficSignMinStockId.replace(':id', stockId)
    return this.del(url, TrafficSignMinimumStock)
  }

  createSupportMinStock(supportMinStockBody: SupportMinimumStock) {
    const url = this._urlSupportMinStock
    return this.post(url, supportMinStockBody, SupportMinimumStock)
  }

  getSupportMinStock(contractId?: string) {
    const url = this._urlSupportMinStock + (contractId ? `?contractId=${contractId}` : '')
    return this.get(url, SupportMinimumStock)
  }

  editSupportMinStock(supportMinStockBody: SupportMinimumStock) {
    const url = this._urlSupportMinStockId.replace(':id', supportMinStockBody.id)
    return this.put(url, supportMinStockBody, SupportMinimumStock)
  }

  deleteSupportMinStock(stockId: string) {
    const url = this._urlSupportMinStockId.replace(':id', stockId)
    return this.del(url, SupportMinimumStock)
  }

  createDeviceMinStock(deviceMinStockBody: DeviceSignalingMinimumStock) {
    const url = this._urlDeviceMinStock
    return this.post(url, deviceMinStockBody, DeviceSignalingMinimumStock)
  }

  getDeviceMinStock(contractId?: string) {
    const url = this._urlDeviceMinStock + (contractId ? `?contractId=${contractId}` : '')
    return this.get(url, DeviceSignalingMinimumStock)
  }

  editDeviceMinStock(deviceMinStockBody: DeviceSignalingMinimumStock) {
    const url = this._urlDeviceMinStockId.replace(':id', deviceMinStockBody.id)
    return this.put(url, deviceMinStockBody, DeviceSignalingMinimumStock)
  }

  deleteDeviceMinStock(stockId) {
    const url = this._urlDeviceMinStockId.replace(':id', stockId)
    return this.del(url, DeviceSignalingMinimumStock)
  }

  getTrafficSignRegister(stockedId: string) {
    const url = this._urlTrafficSigns + `?stockedTrafficSignId=${stockedId}`
    return this.get(url, TrafficSign)
  }

  getDeviceSignalingRegister(stockedId: string) {
    const url = this._urlDeviceSignaling + `?stockedDeviceSignalingId=${stockedId}`
    return this.get(url, DeviceSignaling)

  }

}
